module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABOSURBVHgB3ZBBDQAgCEXBBEYwghE0iZVtYAUbIGzcRebB+TbGBrwDH+AfiGhwZThFpKsy6iJxaxtfpMJVEbEHHUawM82Xrj/d4bgTfYcFOEI87l54dxsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login.png
// module id = bD10
// module chunks = 1